import { IPermissionState } from './model';

export const StudioInitState: IPermissionState = {
  studioPrem: {},
  gamePerm: {},
  envPerm: {},
};
